<div class="content-wrapper">
  <app-content-send
    [attachments]="attachments$ | async"
    [fileAttachments]="fileAttachment$ | async"
    [documentDataDispatcher]="documentDataDispatcher"
    [pdfSize]="pdfSize$ | async"
    [companyInfo]="companyInfo$ | async"
    [document]="document$ | async"
    [documentBilling]="documentBilling$ | async"
    [documentCalculationResult]="documentCalculationResult$ | async"
    [documentNumber]="documentNumber$ | async"
    [documentSettings]="documentSettings$ | async"
    [documentLocale]="documentLocale$ | async"
    [documentDueDate]="documentDueDate$ | async"
    [documentTrackingObject]="documentTrackingObject$ | async"
    [documentType]="documentType$ | async"
    [showBankTransfer]="showBankTransfer$ | async"
    [showCardPayments]="showCardPayments$ | async"
    [showPaypalEc]="showPaypalEc$ | async"
    [bankTransferEnabled]="bankTransferEnabled$ | async"
    [cardPaymentsEnabled]="cardPaymentsEnabled$ | async"
    [paypalEcEnabled]="paypalEcEnabled$ | async"
    [emailDefaults]="emailDefaults$ | async"
    [paymentsSettings]="paymentsSettings$ | async"
    [trackingScreenName]="trackingScreenName"
    [deposit]="deposit$ | async"
    [featureToggles]="featureToggles"
    [account]="account"
    [documentState]="documentState$ | async"
    (onMessageUpdated)="onMessageUpdated($event)"
    (onGrowthCta)="setInTmpCache()"
  >
  </app-content-send>
</div>

<div class="aside-wrapper">
  <ng-container *ngIf="document$ | async as document; else placeholder">
    <app-aside-actions
      [documentDataDispatcher]="documentDataDispatcher"
      [document]="document"
      [documentHasUnsavedChanges]="documentHasUnsavedChanges$ | async"
      [documentId]="documentId$ | async"
      [documentBilling]="documentBilling$ | async"
      [documentCalculationResult]="documentCalculationResult$ | async"
      [documentDueDate]="documentDueDate$ | async"
      [documentDate]="documentDate$ | async"
      [documentFeatureName]="documentFeatureName$ | async"
      [documentPaymentUrl]="documentPaymentUrl$ | async"
      [documentNumber]="documentNumber$ | async"
      [documentState]="documentState$ | async"
      [documentPayments]="documentPayments$ | async"
      [documentSchedule]="documentSchedule$ | async"
      [documentSettings]="documentSettings$ | async"
      [documentRevisionId]="documentRevisionId$ | async"
      [sourceDocumentPreview]="sourceDocumentPreview$ | async"
      [linkedDocumentPreview]="linkedDocumentPreview$ | async"
      [documentTrackingObject]="documentTrackingObject$ | async"
      [documentType]="documentType$ | async"
      [useOutstandingBalance]="useOutstandingBalance"
      [showSendButton]="true"
      [showTotal]="showTotal"
      [showPaid]="showPaid"
      [showPaymentActions]="showPaymentActions"
      [showPaymentReminders]="showPaymentReminders"
      [showI2gMoney]="showI2gMoney"
      [showBankTransfer]="showBankTransfer$ | async"
      [showCardPayments]="showCardPayments$ | async"
      [showPaypalEc]="showPaypalEc$ | async"
      [paypalEcStatus]="paypalEcStatus$ | async"
      [i2gMoneyEnabled]="i2gMoneyEnabled$ | async"
      [bankTransferEnabled]="bankTransferEnabled$ | async"
      [cardPaymentsEnabled]="cardPaymentsEnabled$ | async"
      [paypalEcEnabled]="paypalEcEnabled$ | async"
      [enableSchedules]="enableSchedules"
      [disableSendButton]="disableSendButton"
      [paymentsSettings]="paymentsSettings$ | async"
      [companySettings]="companySettings$ | async"
      [underwritingUrl]="underwritingUrl$ | async"
      [remindersSettings]="remindersSettings$ | async"
      [trackingScreenName]="trackingScreenName"
      [featureToggles]="featureToggles"
      [account]="account"
      [deposit]="deposit$ | async"
      [addDepositForFuture]="addDepositForFuture$ | async"
      [enableDeposits]="enableDeposits"
      [depositRequestFeatureName]="depositRequestFeatureName"
      (sendDocument)="sendDocument()"
      (updateRecurringSchedule)="onUpdateRecurringSchedule($event)"
      (growthCta)="setInTmpCache()"
      (updateDocumentContent)="updateDocumentContent($event)"
      (updateSettingsContent)="updateSettingsContent($event)"
    >
    </app-aside-actions>
  </ng-container>

  <ng-template #placeholder>
    <app-placeholder-aside></app-placeholder-aside>
  </ng-template>
</div>

<app-sending-dialog></app-sending-dialog>

<app-update-client-email-dialog
  [clientName]="clientName$ | async"
  [documentType]="documentType$ | async"
  [trackingScreenName]="trackingScreenName"
>
</app-update-client-email-dialog>
